import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Session replay is switched off inside the private member area and for any
// signed-in visitor, so health, medication and metrics data is never recorded.
export const AnalyticsPrivacy = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    const ph = window.posthog;
    if (!window.__OW_PH_STARTED || !ph || typeof ph.stopSessionRecording !== 'function') return;
    const isPrivate = pathname.startsWith('/my-login') || (user && typeof user === 'object');
    try {
      if (isPrivate) ph.stopSessionRecording();
      else ph.startSessionRecording();
    } catch { /* analytics must never break the app */ }
  }, [pathname, user]);

  return null;
};

export default AnalyticsPrivacy;
